// Écran Réviser (R-CAR-04, R-CAR-06, R-CAR-07).
import { useMemo, useState } from 'react';
import { useMagasin, magasin } from '../donnees/magasin';
import { jourPedagogique } from '@partage/dates';
import { fileDeRevision } from '@partage/programme';
import { RevisionCartes, carteAffichable } from '../composants/RevisionCartes';

export function Reviser() {
  const { etat, bundles } = useMagasin();
  const aujourdhui = jourPedagogique(new Date());
  // La file est figée au montage : les révisions ne la réordonnent pas sous nos yeux.
  const [file] = useState(() => fileDeRevision(etat, aujourdhui));
  const [recto, setRecto] = useState('');
  const [verso, setVerso] = useState('');
  const [gestion, setGestion] = useState(false);
  const total = Object.values(etat.cartes).filter((c) => !c.suspendue).length;
  const cartes = useMemo(() => Object.entries(etat.cartes).map(([id, c]) => ({ id, ...c, contenu: carteAffichable(id, bundles, etat.cartes) })), [etat.cartes, bundles]);

  async function creer() {
    if (!recto.trim() || !verso.trim()) return;
    await magasin.emettre('carte_creee', { carte: `manuelle-${crypto.randomUUID().slice(0, 8)}`, recto: recto.trim(), verso: verso.trim() });
    setRecto(''); setVerso('');
  }

  return (
    <>
      <div className="ligne" style={{ marginBottom: '1em' }}>
        <h2 style={{ margin: 0 }}>Réviser</h2>
        <span className="badge">{file.length} due(s) · {total} actives</span>
        <span className="espace" />
        <button className="petit" onClick={() => setGestion((g) => !g)}>{gestion ? 'Revenir à la révision' : 'Gérer les cartes'}</button>
      </div>
      {!gestion ? <RevisionCartes file={file} titre="Cartes dues" /> : (
        <>
          <div className="carte">
            <h3>Créer une carte</h3>
            <div className="champ"><label htmlFor="recto">Recto (question)</label><input id="recto" value={recto} onChange={(e) => setRecto(e.target.value)} /></div>
            <div className="champ"><label htmlFor="verso">Verso (réponse)</label><textarea id="verso" rows={2} value={verso} onChange={(e) => setVerso(e.target.value)} /></div>
            <button className="principal" onClick={() => void creer()}>Ajouter</button>
          </div>
          <div className="carte">
            <h3>Toutes les cartes actives</h3>
            {cartes.length === 0 ? <p className="vide">Les cartes s’activent à la fin de chaque session.</p> : (
              <table>
                <thead><tr><th>Carte</th><th>Échéance</th><th>Intervalle</th><th></th></tr></thead>
                <tbody>
                  {cartes.map((c) => (
                    <tr key={c.id} style={c.suspendue ? { opacity: 0.5 } : undefined}>
                      <td>{c.contenu?.recto ?? c.id}</td>
                      <td>{c.echeance}</td>
                      <td>{c.intervalle} j</td>
                      <td><button className="petit" onClick={() => void magasin.emettre(c.suspendue ? 'carte_reactivee' : 'carte_suspendue', { carte: c.id })}>{c.suspendue ? 'Réactiver' : 'Suspendre'}</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </>
  );
}
